<script>import { useSvelteUIThemeContext, useSvelteUITheme } from '../../../styles';
import { Text } from '../../Text';
export let element = undefined, className = '';
export { className as class };
const theme = useSvelteUIThemeContext()?.theme || useSvelteUITheme();
const classes = {
    [`${theme.dark} &`]: {
        color: theme.fn.themeColor('dark', 2)
    },
    color: theme.fn.themeColor('gray', 6),
    fontWeight: 500,
    fontSize: theme.fontSizes.xs,
    padding: `${+theme.space.xs.value / 2}px ${+theme.space.sm.value}px`,
    cursor: 'default'
};
</script>

<Text bind:element class={className} {...$$restProps} override={classes}>
	<slot />
</Text>
